"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const svgs_1 = require("@@/assets/svgs");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const material_1 = require("@mui/material");
const Modal_1 = __importDefault(require("@mui/material/Modal"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1({ tempModalOpen, setTempModalOpen, tempData, setTempData, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const roomDataId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    (0, react_1.useEffect)(() => {
        (0, api_1.getData)(`/api/v1/room/temp`).then((res) => __awaiter(this, void 0, void 0, function* () {
            if (res.status === 200) {
                setTempData(res.data.result);
            }
        }));
    }, [tempModalOpen]);
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, Object.assign({ open: tempModalOpen, slotProps: { backdrop: { sx: { bgcolor: maxWidth768 ? 'transparent' : 'var(--gray-80)' } } }, sx: {
            display: 'block',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: maxWidth768 ? '800px' : '480px',
            height: maxWidth768 ? 'unset' : '546px',
            margin: 'auto',
            backgroundColor: '#fff',
        } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { backgroundColor: '#fff', borderRadius: '4px 4px 0 0', height: '100%' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                        display: 'flex',
                        height: '56px',
                        padding: 10,
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        fontSize: 15,
                        lineHeight: '26px',
                        color: '#000000',
                        span: {
                            marginLeft: 5,
                            fontWeight: 700,
                            fontSize: '15px',
                            lineHeight: '18px',
                            color: 'var(--primary-dark)',
                        },
                    } }, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ css: { position: 'absolute', left: 14 }, onClick: () => setTempModalOpen(false) }, { children: (0, jsx_runtime_1.jsx)(svgs_1.HeaderCloseSvg, {}) })), t('임시저장'), (0, jsx_runtime_1.jsx)("span", { children: tempData.length })] })), Boolean(tempData.length) ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', padding: '0 16px', rowGap: '10px' } }, { children: tempData.map((data, index) => {
                        const isProceeding = Boolean(roomDataId == data.id);
                        return ((0, jsx_runtime_1.jsx)(_1.TempList, { isProceeding: isProceeding, tempData: data, setTempModalOpen: setTempModalOpen, setTempData: setTempData, roomDataId: roomDataId }, `room_create_temp_list_${data.id}_${index}`));
                    }) }))) : ((0, jsx_runtime_1.jsx)(NoList, { children: t('임시저장된 내역이 없어요.') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "surface-white", css: {
                        position: 'absolute',
                        width: '100%',
                        bottom: 0,
                        padding: 20,
                        borderRadius: '0 0 4px 4px',
                    } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                            height: '50px',
                            p: '6px',
                            borderRadius: '4px',
                            bgcolor: 'var(--secondary-main) !important',
                            color: 'var(--white)',
                            fontSize: '16px',
                            fontWeight: 700,
                        }, fullWidth: true, onClick: () => setTempModalOpen(false) }, { children: t('닫기') })) }))] })) })));
}
exports.default = default_1;
const NoList = styled_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70%;
  font-size: 16px;
  line-height: 26px;
  color: #000000;
`;
